import React, {useEffect, useState} from 'react';
import {View} from 'react-native';
import {Divider} from 'react-native-paper';
import isFinite from 'lodash/isFinite';

import sy from '~/styles';
import {Text, Pressable, Link, Dialog} from '~/components/controls';
import Format from '~/lib/format';
import PropTypes from 'prop-types';
const LineItem = ({
  icon,
  title,
  price,
  subtitle,
  subtitleColor,
  topMost,
  allowed = true,
  disabled = false,
  cancelled = false,
  editDialog,
  initialValues,
  onValidate,
  onChange,
}) => {
  const [isEditing, setEditing] = useState(false);
  const [errors, setErrors] = useState(null);
  const [changes, setChanges] = useState({});

  useEffect(() => {
    setChanges(initialValues);
  }, [initialValues, isEditing]);

  return (
    <>
      {!topMost && (
        <View style={[sy['px-4']]}>
          <Divider style={sy['bg-gray95']} />
        </View>
      )}
      <View
        style={[
          sy['flex-row'],
          sy['p-4'],
          sy['gap-4'],
          sy['items-center'],
          (!allowed || disabled) && sy['view-disabled'],
        ]}>
        {icon}
        <View style={[sy['flex-1']]}>
          <Pressable
            disabled={!allowed || disabled}
            onPress={() => setEditing(true)}>
            <View style={[sy['flex-row'], sy['justify-between']]}>
              <Text>{title}</Text>
              <Text
                style={[
                  sy.smallRegular,
                  cancelled ? sy['line-through'] : null,
                ]}>
                {allowed && isFinite(price) ? Format.price(price) : <></>}
              </Text>
            </View>
            <Link
              disabled={!allowed || disabled}
              textStyle={[
                sy.smallRegular,
                subtitleColor ? {color: subtitleColor} : sy['text-lightgray'],
              ]}>
              {(() => {
                if (!allowed) {
                  return <>Niet toegestaan</>;
                }

                if (price !== null && price !== undefined) {
                  return subtitle ?? <>Wijzigen</>;
                }

                return <>Opgeven</>;
              })()}
            </Link>
          </Pressable>
        </View>
      </View>
      {editDialog && (
        <Dialog
          visible={isEditing}
          title={title}
          onDismiss={() => setEditing(false)}
          buttons={[
            {
              text: 'Annuleren',
              onPress: () => setEditing(false),
            },
            {
              text: 'OK',
              onPress: () => {
                const {isValid, errors} = onValidate?.(changes) ?? {
                  isValid: true,
                  errors: {},
                };

                if (isValid) {
                  setErrors(null);
                  if (onChange) {
                    onChange({...changes});
                  }

                  setEditing(false);
                } else {
                  setErrors(errors);
                }
              },
            },
          ]}
          options={{noPaddingContent: true}}>
          {editDialog({changes, setChanges, errors})}
        </Dialog>
      )}
    </>
  );
};
LineItem.propTypes = {
  icon: PropTypes.any,
  title: PropTypes.any,
  price: PropTypes.any,
  subtitle: PropTypes.any,
  subtitleColor: PropTypes.any,
  topMost: PropTypes.any,
  allowed: PropTypes.any,
  disabled: PropTypes.any,
  cancelled: PropTypes.any,
  editDialog: PropTypes.any,
  initialValues: PropTypes.any,
  onValidate: PropTypes.any,
  onChange: PropTypes.any,
};

export default LineItem;
